'use strict';

import React, { useCallback, useState } from 'react'

import FormElement from '@/Form/toolkit/FormElement'

import bemit from '@function/bemit'

import DCDashboardStore from '@/Stores/DCDashboard'

import { isTrue } from '@root/utility'

const { moment } = window;

const EMPTY_STATUS = { };

export default function DiscountCodeRow ({ data, fields, ...props })
{
	moment.locale('fr');

	const form_data = DCDashboardStore.useState(function (store)
	{
		return { checked: isTrue(store[data?.id]) };
	});

	const is__used = isTrue(data.used);

	const toggleCB = useCallback(function (e, params)
	{
		DCDashboardStore.update(function (store)
		{
			store[data.id] = isTrue(params?.value);
		});
	},
	[data.id]);

	let output =
	(
		<div className={ 'c-dashboard__row ' + (is__used ? ' row-bg-red' : '') }>

			<div className="c-dashboard__cell DiscountCode-_cb">

				{
					is__used ? undefined :
					(
						<FormElement name="checked"
							type="checkbox" data={ form_data }
							onChange={ is__used ? undefined : toggleCB }
							status={ EMPTY_STATUS }
							readOnly={ is__used }
							className="c-form-element c-form-element--checkbox-row-selection"
						/>
					)
				}

			</div>

			<div className="c-dashboard__cell DiscountCode-product_name">

				<div className="c-dashboard__long-text">
					{ data.product_name }
				</div>

			</div>

			<div className="c-dashboard__cell DiscountCode-price_ref">
				{ data.price?.ref }
			</div>

			<div className="c-dashboard__cell DiscountCode-code">
				{ data.code || data.web_code }
			</div>

			<div className="c-dashboard__cell DiscountCode-code">
				{ moment(data.limit_date).format('DD/MM/YYYY') }
			</div>

			<div className="c-dashboard__cell DiscountCode-status">

				<div className={ bemit('c-chip',
					[is__used ? 'used' : 'available']) }>
					<span className="c-chip__text">
						{ is__used ? 'Utilisé' : 'Disponible' }
					</span>
				</div>

			</div>

			<div className="c-dashboard__cell DiscountCode-Bill_PDF">

				{
					data._bill ?
					(
						<a className="c-btn c-btn--icon c-btn--ghost" target="_blank"
							rel="noreferrer" type="application/pdf"
							href={ '/PDF/facture/' + data._bill.id }>
							<svg className="o-svg-icon o-svg-icon--PDF c-btn__icon">
								<use xlinkHref="/images/icons.svg#svg-icon-PDF"></use>
							</svg>
							{ data._bill.text_number }
						</a>
					)
					: undefined
				}

			</div>

		</div>
	);

	return output;
}